// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA2SET2SITea3qHPmfQEuFOR5p69jQgamc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "helferlainv2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "helferlainv2",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "helferlainv2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "99886413290",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:99886413290:web:2ade8f08b2270571a52e93",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-J9360E974P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;